"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformPersonalizationTokensToHtml = void 0;
const ramda_1 = require("ramda");
const personalization_twig_token_1 = require("@emartech/personalization-twig-token");
const transform_token_object_to_html_1 = require("../../token/transform-token-object-to-html");
const transformPersonalizationTokensToHtml = (html) => {
    return (0, ramda_1.reduceRight)(replaceToToken, html, (0, personalization_twig_token_1.findPlaceholderPositions)(html));
};
exports.transformPersonalizationTokensToHtml = transformPersonalizationTokensToHtml;
function replaceToToken(placeholder, _html) {
    const beforeTwig = _html.slice(0, placeholder.start);
    const afterTwig = _html.slice(placeholder.end);
    const tokenHtml = tokenDataToHtml(placeholder.data);
    return beforeTwig + tokenHtml + afterTwig;
}
function tokenDataToHtml(personalizationTokenMeta) {
    return (0, transform_token_object_to_html_1.transformTokenObjectToHtml)({
        name: personalizationTokenMeta.tokenName,
        type: 'personalization',
        content: {
            a: (0, personalization_twig_token_1.surroundPlaceholders)(personalizationTokenMeta.preview || personalizationTokenMeta.code || personalizationTokenMeta.token.code, personalizationTokenMeta),
        },
        template: '<%= a %>',
        meta: personalizationTokenMeta,
        class: 'cbNonEditable cb-token',
    });
}
//# sourceMappingURL=transform-personalization-tokens-to-html.js.map